import { render, staticRenderFns } from "./simulate.auto.desktop.vue?vue&type=template&id=2db0f5d5&scoped=true"
import script from "./simulate.auto.desktop.vue?vue&type=script&lang=js"
export * from "./simulate.auto.desktop.vue?vue&type=script&lang=js"
import style0 from "./simulate.auto.desktop.vue?vue&type=style&index=0&id=2db0f5d5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db0f5d5",
  null
  
)

export default component.exports